import * as React from "react";
import type { SVGProps } from "react";
const SvgBag01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m5.4 9.624 4.83-5.27a2.4 2.4 0 0 1 3.54 0l4.83 5.27m2.598 1.297-2.733 8.8a1 1 0 0 1-.954.703H6.556a1 1 0 0 1-.954-.697l-2.79-8.8a1 1 0 0 1 .954-1.303h16.477a1 1 0 0 1 .955 1.297"
    />
  </svg>
);
export default SvgBag01;
